import { Container, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Plus from 'mdi-material-ui/Plus'
import { useState } from 'react'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogNotice from '../../views/notice/DialogNotice'
import TableNotice from '../../views/notice/TableNotice'


const NoticeList = () => {
  const [reload, setReload] = useState(0)
  const [show, setShow] = useState(false)

  return (
    <Page title="Notice">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              공지
            </Typography>
          }
          subtitle={
            <Typography variant='body2'>
              공지 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
          <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >등록</Button>
        </BoxWrapper>
        <DialogNotice show={show} setShow={setShow} setReload={setReload}/>
        <Grid item xs={12}>
          <TableNotice reload={reload} setReload={setReload}/>
        </Grid>
      </Grid>
    </Page>
  )
}

export default NoticeList